











































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IVendor } from '@/api/types-vendor'

@Component({
  name: 'VendorInformation'
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean
  @Prop({ type: Object }) value!: IVendor

  getPaymentOptions(): {key: string, name: string}[] {
    return [
      { key: 'ACH', name: 'ACH' },
      { key: 'Check', name: 'Check' },
      { key: '', name: 'Not Set' }
    ]
  }

  toggleHistory(): void {
    console.log(' toggle history ')
  }
}
